// @flow
import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getCollectionData = createPropsSelectorOrm(
  (session, collectionCode) =>
    get(session.Collection.withId(collectionCode), 'ref')
);
